import { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

const AUTH_KEY = "authUserData";
const EXPIRY_KEY = "authExpiryTime";
const EXPIRY_DURATION = 24 * 60 * 60 * 1000; // 24 hours

export const AuthProvider = ({ children }) => {

  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem(AUTH_KEY);
    const expiry = localStorage.getItem(EXPIRY_KEY);

    if (storedUser && expiry) {
      if (Date.now() > Number(expiry)) {
        // 🔥 Expired → clear everything
        localStorage.removeItem(AUTH_KEY);
        localStorage.removeItem(EXPIRY_KEY);
        return null;
      }
      return JSON.parse(storedUser);
    }

    return null;
  });

  const IDENTIFIER_KEY = "lastLoginIdentifier";
  const PRIMARY_ID_KEY = "primaryCompanyId";

  const login = (userData) => {
    localStorage.setItem(AUTH_KEY, JSON.stringify(userData));

    // ✅ Store primary ID permanently for MPIN login
    if (userData?.id) {
      localStorage.setItem(PRIMARY_ID_KEY, userData.id.toString());
    }

    // 🔥 Store email or phone permanently
    const identifier =
      userData.contact_email ||
      userData.official_email ||
      userData.contact_phone ||
      userData.official_phone;

    if (identifier) {
      localStorage.setItem(IDENTIFIER_KEY, identifier);
    }

    const expiryTime = Date.now() + EXPIRY_DURATION;
    localStorage.setItem(EXPIRY_KEY, expiryTime.toString());

    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem(AUTH_KEY);
    localStorage.removeItem(EXPIRY_KEY);
    setUser(null);
  };

  // 🔥 Optional: Auto logout without refresh (checks every minute)
  useEffect(() => {
    const interval = setInterval(() => {
      const expiry = localStorage.getItem(EXPIRY_KEY);

      if (expiry && Date.now() > Number(expiry)) {
        logout();
      }
    }, 60000); // check every 1 min

    return () => clearInterval(interval);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};


// import { createContext, useState, useEffect } from "react";

// export const AuthContext = createContext();

// const AUTH_KEY = "authUserData";
// const EXPIRY_KEY = "authExpiryTime";
// const EXPIRY_DURATION = 24 * 60 * 60 * 1000; // 24 hours

// export const AuthProvider = ({ children }) => {

//   const [user, setUser] = useState(() => {
//     const storedUser = localStorage.getItem(AUTH_KEY);
//     const expiry = localStorage.getItem(EXPIRY_KEY);

//     if (storedUser && expiry) {
//       if (Date.now() > Number(expiry)) {
//         // 🔥 Expired → clear everything
//         localStorage.removeItem(AUTH_KEY);
//         localStorage.removeItem(EXPIRY_KEY);
//         return null;
//       }
//       return JSON.parse(storedUser);
//     }

//     return null;
//   });

//   const login = (userData) => {
//     console.log("SAVING USER:", userData);

//     localStorage.setItem(AUTH_KEY, JSON.stringify(userData));

//     // 🔥 Set expiry time
//     const expiryTime = Date.now() + EXPIRY_DURATION;
//     localStorage.setItem(EXPIRY_KEY, expiryTime.toString());

//     setUser(userData);
//   };

//   const logout = () => {
//     localStorage.removeItem(AUTH_KEY);
//     localStorage.removeItem(EXPIRY_KEY);
//     setUser(null);
//   };

//   // 🔥 Optional: Auto logout without refresh (checks every minute)
//   useEffect(() => {
//     const interval = setInterval(() => {
//       const expiry = localStorage.getItem(EXPIRY_KEY);

//       if (expiry && Date.now() > Number(expiry)) {
//         logout();
//       }
//     }, 60000); // check every 1 min

//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <AuthContext.Provider value={{ user, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// import { createContext, useState, useEffect } from "react";

// export const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(
//     JSON.parse(localStorage.getItem("authUserData")) || null
//   );

//   const login = (userData) => {
//   console.log("SAVING USER:", userData);
//   console.log("LEADS:", userData.leads);

//   localStorage.setItem("authUserData", JSON.stringify(userData));

//   const stored = JSON.parse(localStorage.getItem("authUserData"));
//   console.log("STORED LEADS:", stored.leads);

//   setUser(userData);
// };

//   const logout = () => {
//     localStorage.removeItem("authUserData");
//     setUser(null);
//   };

//   return (
//     <AuthContext.Provider value={{ user, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// import { createContext, useState, useEffect } from "react";

// export const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(
//     JSON.parse(localStorage.getItem("authUserData")) || null
//   );

//   const login = (userData) => {
//     setUser(userData);
//     localStorage.setItem("authUserData", JSON.stringify(userData));
//   };

//   const logout = () => {
//     localStorage.removeItem("authUserData");
//     setUser(null);
//   };

//   return (
//     <AuthContext.Provider value={{ user, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };



// // src/context/AuthContext.jsx
// import { createContext, useState, useEffect } from "react";

// export const AuthContext = createContext();

// export function AuthProvider({ children }) {
//   const [authUser, setAuthUser] = useState(
//     JSON.parse(localStorage.getItem("authUserData"))
//   );

//   // Sync React state with localStorage updates
//   useEffect(() => {
//     const handler = () => {
//       setAuthUser(JSON.parse(localStorage.getItem("authUserData")));
//     };

//     window.addEventListener("storage", handler);
//     return () => window.removeEventListener("storage", handler);
//   }, []);

//   return (
//     <AuthContext.Provider value={{ authUser, setAuthUser }}>
//       {children}
//     </AuthContext.Provider>
//   );
// }
